import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import useCompanyContext from 'common/hooks/useCompanyContext';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import { useTeamMembers } from 'features/Team/hooks/useTeamMembers';
import * as routes from 'features/Team/routes';

import useTransactionsSearch from '../Transactions/hooks/useTransactionsSearch';
import locales from './locales';

interface EmployeeTransactionsHeaderProps {
  companyUserId: string;
  currency: string;
  loading: boolean;
}

const EmployeeTransactionsHeader: FC<EmployeeTransactionsHeaderProps> = ({
  companyUserId,
  currency,
  loading,
}) => {
  const { companyProfileId } = useCompanyContext();
  const { teamMembers } = useTeamMembers(companyProfileId);
  const accessedEmployee = teamMembers.find(
    (member) => member.companyUserOrInvitationId === companyUserId,
  );
  const { transactionsTotalAmount } = useTransactionsSearch({
    searchTerm: '',
  });

  return (
    <>
      <BackButton to={routes.members} />
      <Flex alignItems="center" paddingBottom="space-32" paddingTop="space-24">
        <Flex alignItems="start" flexDirection="column">
          <Heading
            size="lg"
            variant="number"
            {...(loading && { filter: 'blur(15px)' })}
          >
            {locales.formatString(locales.employeeTransactionsTitle, {
              name: `${accessedEmployee?.firstName} ${accessedEmployee?.lastName}`,
            })}
          </Heading>

          <Text
            marginTop="space-16"
            variant="light"
            {...(loading && { filter: 'blur(15px)' })}
          >
            {`${formatAmount({
              currency,
              forcePlusSign: false,
              value: transactionsTotalAmount,
            })} ${locales.spentThisMonth}`}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default EmployeeTransactionsHeader;
